/**
 * In the front-end, adds modifier classes for
 * - first inner block
 * - last inner block
 */
(() => {
    let innerBlocks = document.querySelectorAll('.inner-blocks');

    if (!innerBlocks.length) {
        return;
    }

    for (let i = 0; i < innerBlocks.length; i++) {
        for (let j = 0; j < innerBlocks[i].childNodes.length; j++) {
            if (
                innerBlocks[i].childNodes[j].nodeType !== 3 &&
                typeof innerBlocks[i].childNodes[j].classList !== 'undefined'
            ) {
                innerBlocks[i].childNodes[j].classList.add(
                    '-first-inner-block'
                );
                break;
            }
        }
        for (let j = innerBlocks[i].childNodes.length - 1; j >= 0; j--) {
            if (
                innerBlocks[i].childNodes[j].nodeType !== 3 &&
                typeof innerBlocks[i].childNodes[j].classList !== 'undefined'
            ) {
                innerBlocks[i].childNodes[j].classList.add('-last-inner-block');
                break;
            }
        }
    }
})();
